import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SummaryButton from '@components/SummaryButton';
import SlideToggleContent from '@components/SlideToggleContent';
import { stripePriceConverter } from '@services/transform';

function ScheduledCheckoutItem(props) {
  const {
    data,
    refData,
    costData,
    scheduleData,
    renderDetail,
    paymentMethod
  } = props;
  const [isVisible, setIsVisible] = useState(false);
  const { serviceType, week, day } = data;
  const { serviceTypes } = refData;
  const { title } = serviceTypes[serviceType];

  const itemCost = costData.find(
    item => item.week === week && day === item.day
  );

  const { cost } = itemCost || {};

  const totalPrice = `$${stripePriceConverter(cost)}`;

  return (
    <React.Fragment>
      <SummaryButton
        onClick={() => {
          setIsVisible(!isVisible);
        }}
        flex={1}
        mb={4}
        type="button"
        subtitle={totalPrice}
        leftIcon={serviceType}
        title={title}
        expanded={isVisible}
      />
      <SlideToggleContent isVisible={isVisible}>
        <React.Fragment>
          {renderDetail(data, itemCost, scheduleData, paymentMethod)}
        </React.Fragment>
      </SlideToggleContent>
    </React.Fragment>
  );
}

ScheduledCheckoutItem.propTypes = {
  data: PropTypes.object,
  refData: PropTypes.object,
  renderDetail: PropTypes.func,
  costData: PropTypes.array,
  scheduleData: PropTypes.object,
  paymentMethod: PropTypes.string
};

export default ScheduledCheckoutItem;
